/* eslint no-undef: 'off' */
import $ from "jquery";

if (window.location.pathname === "/chapters/" || window.location.pathname === "/app/chapters/") {
  (() => {
    let storedData = [];

    const setupLocalStorage = () => {
      // if (localStorage.getItem('starterdata')) {
      //     localStorage.removeItem('starterdata');
      // } else {
      const starter_data = $(".Chapter--Survey").data("data_survey");
      const obj = {};

      starter_data.forEach((element, index) => {
        obj[`${index}`] = element;
      });
      localStorage.setItem("stepdata", JSON.stringify(obj));

      storedData = JSON.parse(localStorage.getItem("stepdata")) || {};

      $(".option_val").each(function (i, el) {
        $(el).val(storedData[i]["text"]);
      });

      let type = $(".type").val();
      $(".options_step").each(function (i, el) {
        if (type === "text") {
          $(el).html(storedData[i]["text"]);
        } else if (type === "image") {
          $(el).attr("src", storedData[i]["image"]);
        }
      });
    };

    // const chooseStarterData = () => {

    //     $('.chooseStarter').on('click', function () {

    //         const selectedValue = $(this).val();
    //         const radioName = $(this).attr('name');
    //         const index = radioName.match(/\d+/)[0];

    //         storedData = JSON.parse(localStorage.getItem("stepdata")) || {};

    //         if (storedData.hasOwnProperty(index)) {
    //             storedData[index] = selectedValue;
    //         } else {
    //             storedData[index] = selectedValue;
    //         }

    //         localStorage.setItem("stepdata", JSON.stringify(storedData));

    //         // const retrievedData = JSON.parse(localStorage.getItem("stepdata"));
    //     });

    //     $("#js-starterButton").on('click', function () {

    //         $('.options_step').each(function (i, el) {
    //             $(el).html(storedData[i]);
    //         });
    //         $('.option_val').each(function (i, el) {
    //             $(el).val(storedData[i]);
    //         });
    //     });

    // }

    const chooseStepperData = () => {
      $("#js-stepButtonSurvey").on("click", function () {
        storedData = JSON.parse(localStorage.getItem("stepdata")) || {};
        let selectedValue = $(".option_val:checked").val();
        if (selectedValue === storedData["0"]["text"]) {
          delete storedData["1"];
        } else if (selectedValue === storedData["1"]["text"]) {
          delete storedData["0"];
        }

        // console.log(storedData);
        // localStorage.setItem("stepdata", JSON.stringify(sortedData));

        let sortedData = {};
        let newIndex = 0;
        $.each(storedData, function (index, value) {
          sortedData[newIndex] = value;
          newIndex++;
        });

        // console.log(sortedData);

        localStorage.setItem("stepdata", JSON.stringify(sortedData));
        let type = $(".type").val();

        if (Object.keys(sortedData).length === 1) {
          $(".Chapter--Survey").removeProp("open").hide();
          $("#Chapter__Complete--Survey").prop("open", true).show();
          if (type === "text") {
            $(".result-answer span").text(sortedData["0"]["text"]);
          } else if (type === "image") {
            $(".result-answer img").attr("src", sortedData["0"]["image"]);
          }
          $('input[name="answer_survey"]').val(sortedData["0"]["text"]);
          $('input[name="answer_image"]').val(sortedData["0"]["image"]);
          $(".js-mi-Character--ChapterCompleted").show();
        } else {
          $("#Chapter__Complete--Survey").hide();
          $('input[type=radio][name="options"]').prop("checked", false);
          // $(this).prop("disabled", true);

          // let optionElements = $('.option_val');
          // let stepElements = $('.options_step');

          // optionElements.each(function (i, el) {
          //     $(el).val(sortedData[i]);
          // });

          // stepElements.each(function (i, el) {
          //     $(el).html(sortedData[i]);
          // });

          // storedData = JSON.parse(localStorage.getItem("stepdata")) || {};

          $(".option_val").each(function (i, el) {
            $(el).val(sortedData[i]["text"]);
          });

          $(".options_step").each(function (i, el) {
            if (type === "text") {
              $(el).html(sortedData[i]["text"]);
            } else if (type === "image") {
              $(el).attr("src", sortedData[i]["image"]);
            }
          });
        }
      });
    };

    const saveSurvey = () => {
      $(document).on("click", ".btn-submit-survey", function () {
        let data = {
          question: $("#question_survey").val(),
          answer: $("#answer_survey").val(),
          answer_image: $("#answer_image").val(),
          id: $("#id_survey").val(),
        };

        let postData = {
          nonce: "n0nc3",
          action: "save_survey",
          data: data,
        };

        $.ajax({
          type: "POST",
          url: themeParams.ajaxUrl,
          data: postData,
          dataType: "json", // and this
          success: function () {
              // console.log('test', response);
              $('.js-PopupSurvey--Button').removeClass('js-PopupSurvey--Button')
              $('.js-PopupSurvey--Popup').remove()
          },
          // error: function (xhr, textStatus, errorThrown) {
          //     // console.error("Error:", textStatus, errorThrown);
          // }
        });
      });
    };

    const init = () => {
      setupLocalStorage();
      // chooseStarterData();
      chooseStepperData();
      saveSurvey();
    };

    try {
      init();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  })();
}
